import React from 'react';

const FieldWrapper = ({children, rowClass = '', colClass = '', ...props}) => {
    return (
      <div className={`row ${rowClass}`}>
        <div className={`col-sm-12 col-md-12 col-lg-12 ${colClass}`}>
          {children}
        </div>
      </div>
    );
}

export default FieldWrapper;


/** WEBPACK FOOTER **
 ** ./src/components/FieldWrapper.js
 **/